import { t } from 'i18next';
import { FieldValues } from 'react-hook-form';

import AutocompleteField from '../v2/Autocomplete/AutocompleteField';
import { AutocompleteFieldProps } from '../v2/Autocomplete/types';

export enum AutocompleteBooleanOptionValue {
  TRUE = 'yes',
  FALSE = 'no',
}

const options = [
  {
    label: t('actions.yes'),
    value: AutocompleteBooleanOptionValue.TRUE,
    _entity: AutocompleteBooleanOptionValue.TRUE,
  },
  {
    label: t('actions.no'),
    value: AutocompleteBooleanOptionValue.FALSE,
    _entity: AutocompleteBooleanOptionValue.FALSE,
  },
];

type Props<T extends FieldValues> = Omit<AutocompleteFieldProps<T, boolean>, 'options'>;

export default function AutocompleteBoolean<T extends FieldValues>({
  ...rest
}: Props<T>) {
  return <AutocompleteField {...rest} options={options} />;
}
